import App from "@/views/App.vue";

export default [
  {
    path: "/leads",
    name: "leads",
    component: App,
    redirect: { name: "leadsHome" },
    children: [
      {
        path: "",
        name: "leadsHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewLeadsList.vue"),
        meta: {
          displayName: "displayName.leads",
          requiresAuth: true,
        },
      },
      {
        path: "/favoritos",
        name: "favoritesHome",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewLeadsList.vue"),
        meta: {
          displayName: "displayName.favorites",
          requiresAuth: true,
        },
      },
    ],
  },
];
